module.exports = __webpack_public_path__ + "static/img/choose_bg_2.524c46df.png";